import { ReportContasPagarAnaliticoColumnsForm } from "../../../presentation/schemas/reports/contasPagarAnaliticoReport";
import { ISaveContasPagarAnaliticoFiltrosUseCase } from "../../../presentation/useCases/create/save_contas_pagar_analitico_filtros_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * SaveContasPagarAnaliticoFiltrosUseCase
 */

export class SaveContasPagarAnaliticoFiltrosUseCase implements ISaveContasPagarAnaliticoFiltrosUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async execute(form: ReportContasPagarAnaliticoColumnsForm): Promise<void> {
    var listaStr: string[] = [];

    if (form.nroContasPagar) { listaStr.push('NR_CONTAS_PAGAR'); }
    if (form.centroCusto) { listaStr.push('CENTRO_CUSTO'); }
    if (form.ordemCompra) { listaStr.push('OC'); }
    if (form.fornecedor) { listaStr.push('FORNECEDOR'); }
    if (form.bancoPagamento) { listaStr.push('BANCO_PAGAMENTO'); }
    if (form.nroDocumento) { listaStr.push('NRO_DOCUMENTO'); }
    if (form.responsavel) { listaStr.push('RESPONSAVEL'); }
    if (form.status) { listaStr.push('STATUS'); }
    if (form.titulo) { listaStr.push('TITULO'); }
    if (form.subconta) { listaStr.push('SUBCONTA'); }
    if (form.dataPagar) { listaStr.push('DATA_A_PAGAR'); }
    if (form.dataPago) { listaStr.push('DATA_PAGO'); }
    if (form.valorPagar) { listaStr.push('VALOR_A_PAGAR'); }
    if (form.valorPago) { listaStr.push('VALOR_PAGO'); }
    if (form.contaBancaria) { listaStr.push('CONTA_BANCARIA'); }
    if (form.observacao) { listaStr.push('OBSERVACOES'); }
    if (form.notaFiscal) { listaStr.push('NOTA_FISCAL'); }
    if (form.notaFiscalEspecial) { listaStr.push('NOTA_FISCAL_ESPECIAL'); }
    if (form.bdi) { listaStr.push('BDI'); }
    if (form.bdi2) { listaStr.push('BDI2'); }
    if (form.nroMedicao) { listaStr.push('MEDICAO'); }
    if (form.totalBdi) { listaStr.push('TOTALBDI'); }
    if (form.totalBdi2) { listaStr.push('TOTALBDI2'); }
    if (form.formaPagamento) { listaStr.push('FORMA_PAGAMENTO'); }
    if (form.informacaoGeral) { listaStr.push('INFORMACOES_GERAIS'); }
    if (form.dataCriacao) { listaStr.push('DATA_CRIACAO'); }
    if (form.dataCompetencia) { listaStr.push('DATA_COMPETENCIA'); }
    if (form.funcionarioFolha) { listaStr.push('FUNCIONARIO_FOLHA'); }

    await this.repository.saveContasPagarAnaliticoFiltros(listaStr.join(','));

  }
}
